const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { withRouter } = require("react-router-dom");
const get = require('lodash/object/get');
// @commons
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');
const ProductBannerHeader = require('components/commons/productBannerHeader/productBannerHeader');

const { LoadingSection } = require('commonsComponents/loadingSection');
// @components
const LoanCollectiveTooltip = require('../../../loansAndMortgages/loanCollectiveTooltip/loanCollectiveTooltip');
//@constants
const { findPurposeById } = require('../../contractPayrollLoan/payrollLoanPurposes');
const PAYROLL_LOAN_RECORD_STATUS = require('../../../../loansConstants/payrollLoanRecordStatus');
const {
    multichannelAlias: { PAYROLL_LOAN_ALIAS }
} = require('../../../../loansConstants/index');
// @utilities
const {
    PAGE_LOANS_MORTGAGES,
    recordLink,
    recordLinkV2
} = require('utilities/tagging');
//@helpers
const { buildAresLoanWafferActions } = require('../../../../loansUtilities/loansHelper');
const { toCamelCase } = require('utilities/stringHelper');
const { bannerStatus, bannerShow } = require('../../../../loansUtilities/bannerStatusHelper');
const LoansMortgagesBannerHeader = require('../../../loansAndMortgages/loansMortgagesBannerHeader/loansMortgagesBannerHeader');

class PayrollLoanRecordStatus extends React.Component {
    getConfig(type) {
        const { immPayrollLoanRecordStatus, recoveryProcessType } = this.props;
        const status = immPayrollLoanRecordStatus.get("state");

        const config = get(PAYROLL_LOAN_RECORD_STATUS, [status, type]);
        const analyticsTag = get(PAYROLL_LOAN_RECORD_STATUS, [status, 'analyticsTag']);
        const analyticsTagV2Button = get(PAYROLL_LOAN_RECORD_STATUS, [status, 'analyticsTagV2Button']);

        return (type === 'button' && config)
            ? {
                  ...config,
                  isOKButton: true,
                  handleAnalyticsTagOKButton: analyticsTagV2Button ? () => recordLinkV2(buildAresLoanWafferActions({ ...analyticsTagV2Button })) : undefined,
                  callback: () => {
                      if (analyticsTag) recordLink(PAGE_LOANS_MORTGAGES, 'prestamo personal', `${analyticsTag}/continuar`);
                      if (analyticsTagV2Button) recordLinkV2(buildAresLoanWafferActions({ ...analyticsTagV2Button }));
                      recoveryProcessType();
                      this.props.history.push(config.link);
                  }
              }
            : config;
    }

    getCancelButtonButtonConfig() {
        const { immPayrollLoanRecordStatus } = this.props;
        const prefix = 'payrollLoanRecordStatus';
        const status = immPayrollLoanRecordStatus.get('state');
        const analyticsTag = get(PAYROLL_LOAN_RECORD_STATUS, [status, 'analyticsTag']);
        const analyticsTagV2Cancel = get(PAYROLL_LOAN_RECORD_STATUS, [status, 'analyticsTagV2Cancel']);
        const config = this.getConfig('notInterestedButtonConfig');
        return {
            confirmation: true,
            handleAnalyticsTag: analyticsTagV2Cancel ? () => recordLinkV2(buildAresLoanWafferActions({ ...analyticsTagV2Cancel })) : undefined,
            text: config && config.text ? config.text : (__CONTACT_CENTER__ ? `${prefix}-notInterestedAnymoreFormalFormat` : `${prefix}-notInterestedAnymore`),
            onAccept: () => {
                if (analyticsTag) recordLink(PAGE_LOANS_MORTGAGES, 'prestamo personal', `${analyticsTag}/cancelar`);
                this.props.cancelLoanRecord();
            },
            ...(config && config.styles)
        };
    }

    isVisible(status) {
        const { cardDeniedVisible, immFlagBasedFeatures } = this.props;
        const banner = get(PAYROLL_LOAN_RECORD_STATUS, status);
        let show = false;

        if (banner) {
            // If the banner exists could be showed
            show = !(get(banner, 'checkFlag', false) && !cardDeniedVisible);
            show = show && immFlagBasedFeatures;
        }

        return show;
    }

    buildBadge() {
        return (
            <CollectiveTag
                extraClass="product-banner-header__container-badge"
                productAlias={PAYROLL_LOAN_ALIAS}
                tooltipContent={<LoanCollectiveTooltip />}
            />
        );
    }

    buildBannerContent() {
        const { immPayrollLoanRecordStatus, clientName, history } = this.props;

        const title = this.getConfig('title');
        const collectiveTag = this.buildBadge();
        const subtitle = this.getConfig('subtitle');
        const messageConfig = this.getConfig('messages');
        const buttonConfig = this.getConfig('button');
        const notInterestedButtonStatuses = this.getConfig('notInterestedButton');
        const status = immPayrollLoanRecordStatus.get('state');
        const purposeId = immPayrollLoanRecordStatus.get('purpose');
        const productSubType = immPayrollLoanRecordStatus.get('productSubType');
        const isFetching = immPayrollLoanRecordStatus.get('isFetching');
        const purpose = findPurposeById(purposeId);
        const purposeIcon = purpose ? purpose.icon : null;
        const customButtonConfig = notInterestedButtonStatuses ? this.getCancelButtonButtonConfig() : null;
        const userName = toCamelCase(clientName).trim();
        const bannerKeys = bannerStatus(status)
        const bannerShowHeader = bannerShow(status)
        const analyticsTagView = get(PAYROLL_LOAN_RECORD_STATUS, [status, 'analyticsTagView']);

        const recordStatus = !isFetching ?
            (
                <ProductBannerHeader
                    badge={collectiveTag}
                    title={title}
                    image={purposeIcon}
                    subtitle={subtitle}
                    messages={messageConfig}
                    button={buttonConfig}
                    customButton={customButtonConfig}
                    setVisibleStep={this.props.setVisibleStep}
                    analyticsTagView={analyticsTagView}
            />
        ) :
                <LoadingSection />;

        const recordStatusBannerStatus = !isFetching && bannerShowHeader ?
            (
                <LoansMortgagesBannerHeader
                    clientName={userName}
                    bannerKeys={bannerKeys}
                    history={history}
                    status={status}
                    customButton={customButtonConfig}
                    setVisibleStep={this.props.setVisibleStep}
                    analyticsTagView={analyticsTagView}
                />
            ) :
            null;
        return productSubType === '804' ? recordStatus : productSubType === '810' && recordStatusBannerStatus;
    }

    render() {
        const { immPayrollLoanRecordStatus } = this.props;
        const status = immPayrollLoanRecordStatus.get('state');
        const show = this.isVisible(status);
        return show ? this.buildBannerContent() : null;
    }
}

PayrollLoanRecordStatus.propTypes = {
    immPayrollLoanRecordStatus: PropTypes.object.isRequired,
    cancelLoanRecord: PropTypes.func.isRequired,
    cardDeniedVisible: PropTypes.bool.isRequired,
    immFlagBasedFeatures: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    clientName: PropTypes.string,
    setVisibleStep: PropTypes.func,
    recoveryProcessType: PropTypes.func
};

module.exports = withRouter(PayrollLoanRecordStatus);
